/**
 * Map range.
 */
export const mapRange = (num: number, inMin: number,
  inMax: number, outMin: number, outMax: number): number => {
  let value: number = ((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  value = value < outMin ? outMin : value;
  value = value > outMax ? outMax : value;
  return value;
};

/**
 * Correct calculation of angle based on arctangent.
 *
 * @param x - x co-ordnidate 
 * @param y - y co-ordnidate
 * @returns Return the angle based on the arc tangent.
 */
export const getAtan = (x: number, y: number): number => {
  let alpha = Math.atan(y / x);
  if (x < 0) {
    if (y < 0) {
      alpha -= Math.PI;
    } else {
      alpha += Math.PI;
    }
  }
  return alpha;
};

/**
 * Determine if a point is inside of a circle.
 * 
 * @param circle_x - x centre of the circle
 * @param circle_y - y centre of the cirlce
 * @param radius - raduis of the circle
 * @param x - x co-ordnidate 
 * @param y - y co-ordnidate
 * @returns Return "true" if the point is within the circle and "false" if not.
 */
export const isInsideCircle = (circle_x: number, circle_y : number, radius: number, x: number, y: number): boolean => {
  // Compare radius of circle with distance of its center from given point.
  if ((x - circle_x) * (x - circle_x) + (y - circle_y) * (y - circle_y) <= radius * radius)
    return true;
  else
    return false;
};